import React from "react";
import Cookies from 'js-cookie';
import { Navigate, BrowserRouter as Router, Routes, Route, useParams } from "react-router-dom";
import "./App.css";
import ChatLogin from "./ChatV1Login";
import Chat from "./Console/Chat";
import Dashboard from "./Console/Dashboard";
import LoginPage from "./Console/LoginPage";
import { useLogout } from "./Console/Common/Authentication";
import Sessions from "./Console/Sessions";
import SessionLog from "./Console/Sessions/SessionLog";
import Structured from "./Console/Structured";  
import IssueEditor from "./Console/Structured/IssueEditor";

const App = () => {
    const [token, setToken] = React.useState(Cookies.get('token') || null);
    const isAuthenticated = !!token;

    // Verify token on each authenticated page load
    React.useEffect(() => {
        const verifyToken = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_API_URL}/token/validate`, 
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ token }),
                });

                const data = await response.json();

                if (!data.valid) {
                    throw new Error('Token verification failed');
                }
            } catch (error) {
                console.error('Token verification failed:', error);
                Cookies.remove('token'); // Remove the invalid token cookie
                setToken(null);
                window.location.href = '/console/login'; // Redirect to the login page
            }
        };

        if (isAuthenticated) {
            verifyToken();
        }
    }, [isAuthenticated, token]);

    return (
        <Router>
            <Routes>
                { /* Legacy Routes */ }
                <Route
                    path="/chat-v1"
                    element={<ChatLogin />}
                />
                { /* Console Routes */ }
                <Route 
                    path="/" 
                    element={isAuthenticated ? <Navigate to="/console" replace /> : <Navigate to="/console/login" replace />} 
                />
                <Route
                    path="/console/login"
                    element={isAuthenticated ? <Navigate to="/console" replace /> : <LoginPage />}
                />
                <Route
                    path="/console"
                    element={isAuthenticated ? <Dashboard token={ token } /> : <Navigate to="/console/login" replace />}
                />
                <Route
                    path="/console/sessions"
                    element={isAuthenticated ? <Sessions token={ token } /> : <Navigate to="/console/login" replace />}
                />
                <Route
                    path="/console/sessions/log/:id_session"
                    element={isAuthenticated ? <SessionLog token={ token } /> : <Navigate to="/console/login" replace />}
                />
                <Route
                    path="/console/chat"
                    element={isAuthenticated ? <Chat token={ token } /> : <Navigate to="/console/login" replace />}
                />
                <Route
                    path="/console/structured"
                    element={isAuthenticated ? <Structured token={ token } /> : <Navigate to="/console/login" replace />}
                />
                <Route
                    path="/console/structured/issue/:id_issue"
                    element={isAuthenticated ? <IssueEditor token={ token } /> : <Navigate to="/console/login" replace />}
                />
            </Routes>
        </Router>
    );
};

const HomePage = () => {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Renox Assistant</h1>
        <p>Please select an option: </p>
        <div>
          <button onClick={() => window.location.href = "/chat-login"}>
            Access Chat
          </button>
        </div>
        <div>
          <button onClick={() => window.location.href = "/console"}>
            Access Console
          </button>
        </div>
      </header>
    </div>
  );
}

export default App;